import React, { Component,useState,useEffect } from "react";
import store from "@/redux/store";
import { useNavigate, useLocation } from "react-router-dom";


import { Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/20/solid'



export function Export({...props}) {
    const [show, setShow] = useState(true)
    const navigate = useNavigate();
    const location = useLocation();
        
    
  return (
    <>
 
        
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition show={show}>
            <div className="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0 pt-0.5">
                  </div>
                  <div className="ml-3 w-0 flex-1">
                    <p className="mt-1 text-sm text-gray-500">{props.item.message}</p>
                    {props.item.link &&
                    <div className="mt-4 flex">
                      <a href={props.item.link} target="_blank"
                        type="button"
                        className="inline-flex items-center rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      >
                        Download
                      </a>
                    </div>
                  }
                  </div>
                  <div className="ml-4 flex flex-shrink-0">
                    <button
                      type="button"
                      onClick={() => {
                        setShow(false)
                      }}
                      className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon aria-hidden="true" className="h-5 w-5" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
      
    </>
      );
}       